var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortada({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27.5px",
    height: "27.5px",
    viewBox: "0 0 27.5 27.5",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "television-inteligente",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7148 0L2.28516 0C1.02512 0 0 1.02512 0 2.28516L0 17.5195C0 18.7796 1.02512 19.8047 2.28516 19.8047L8.90703 19.8047L8.36362 21.4893C7.09795 21.7546 6.14453 22.8793 6.14453 24.2227L6.14453 25.2383C6.14453 25.659 6.48558 26 6.90625 26L19.0938 26C19.5144 26 19.8555 25.659 19.8555 25.2383L19.8555 24.2227C19.8555 22.8793 18.9021 21.7546 17.6364 21.4893L17.093 19.8047L23.7148 19.8047C24.9749 19.8047 26 18.7796 26 17.5195L26 2.28516C26 1.02512 24.9749 0 23.7148 0L23.7148 0ZM18.332 24.2227L18.332 24.4766L7.66797 24.4766L7.66797 24.2227C7.66797 23.5226 8.23748 22.9531 8.9375 22.9531L17.0625 22.9531C17.7625 22.9531 18.332 23.5226 18.332 24.2227L18.332 24.2227ZM9.98359 21.4297L10.5078 19.8047L15.4922 19.8047L16.0165 21.4297L9.98359 21.4297ZM24.4766 17.5195C24.4766 17.9395 24.1349 18.2812 23.7148 18.2812L2.28516 18.2812C1.86514 18.2812 1.52344 17.9395 1.52344 17.5195L1.52344 2.28516C1.52344 1.86514 1.86514 1.52344 2.28516 1.52344L23.7148 1.52344C24.1349 1.52344 24.4766 1.86514 24.4766 2.28516L24.4766 17.5195Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1406 4.0625L19.0938 4.0625C18.6731 4.0625 18.332 4.40355 18.332 4.82422L18.332 7.87109C18.332 8.29177 18.6731 8.63281 19.0938 8.63281L22.1406 8.63281C22.5613 8.63281 22.9023 8.29177 22.9023 7.87109L22.9023 4.82422C22.9023 4.40355 22.5613 4.0625 22.1406 4.0625L22.1406 4.0625ZM21.3789 7.10938L19.8555 7.10938L19.8555 5.58594L21.3789 5.58594L21.3789 7.10938Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1406 11.1719L19.0938 11.1719C18.6731 11.1719 18.332 11.5129 18.332 11.9336L18.332 14.9805C18.332 15.4011 18.6731 15.7422 19.0938 15.7422L22.1406 15.7422C22.5613 15.7422 22.9023 15.4011 22.9023 14.9805L22.9023 11.9336C22.9023 11.5129 22.5613 11.1719 22.1406 11.1719L22.1406 11.1719ZM21.3789 14.2188L19.8555 14.2188L19.8555 12.6953L21.3789 12.6953L21.3789 14.2188Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4 4.8999L16 4.8999",
    id: "New-shape-2",
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7.6001L16 7.6001",
    id: "New-shape",
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.199 11.3999L15.901 11.3999Q15.96 11.3999 16.0179 11.4114Q16.0757 11.4229 16.1302 11.4455Q16.1847 11.4681 16.2338 11.5009Q16.2828 11.5336 16.3246 11.5753Q16.3663 11.6171 16.399 11.6661Q16.4318 11.7152 16.4544 11.7697Q16.477 11.8242 16.4885 11.882Q16.5 11.9399 16.5 11.9989L16.5 14.3009Q16.5 14.3599 16.4885 14.4178Q16.477 14.4756 16.4544 14.5301Q16.4318 14.5846 16.399 14.6337Q16.3663 14.6827 16.3246 14.7245Q16.2828 14.7662 16.2338 14.799Q16.1847 14.8317 16.1302 14.8543Q16.0757 14.8769 16.0179 14.8884Q15.96 14.8999 15.901 14.8999L4.199 14.8999Q4.14 14.8999 4.08214 14.8884Q4.02428 14.8769 3.96977 14.8543Q3.91527 14.8317 3.86621 14.799Q3.81716 14.7662 3.77544 14.7245Q3.73372 14.6827 3.70095 14.6337Q3.66817 14.5846 3.64559 14.5301Q3.62302 14.4756 3.61151 14.4178Q3.6 14.3599 3.6 14.3009L3.6 11.9989Q3.6 11.9399 3.61151 11.882Q3.62302 11.8242 3.64559 11.7697Q3.66817 11.7152 3.70095 11.6661Q3.73372 11.6171 3.77544 11.5753Q3.81716 11.5336 3.86621 11.5009Q3.91527 11.4681 3.96977 11.4455Q4.02428 11.4229 4.08214 11.4114Q4.14 11.3999 4.199 11.3999Z",
    id: "Rectangle-13",
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortada);
export default __webpack_public_path__ + "static/media/portada.4b94cc05fe88e961d1904e7c449184d7.svg";
export { ForwardRef as ReactComponent };